import { useAssistantSelectionStore } from '@/modules/assistant/shared/assistant-store';
import type { AssistantScope } from '@/modules/assistant/services/assistant-scope';

/**
 * The open conversation, when it belongs to this scope.
 *
 * The stored thread id is only honoured for the family it was opened in: a
 * tenant conversation id means nothing to the platform family, and asking the
 * platform family for it would be a refusal dressed up as a conversation.
 */
export function useSelectedAssistantThreadId(scope: AssistantScope): string | null {
  const threadId = useAssistantSelectionStore((state) => state.threadId);
  const storedScope = useAssistantSelectionStore((state) => state.scope);
  return storedScope === scope ? threadId : null;
}

/** Opens a conversation, or clears the selection with null. */
export function useSelectAssistantThread() {
  return useAssistantSelectionStore((state) => state.selectThread);
}
